export function itemTypeClass(type) {
  if (!type) return 'unknown';
  return type.toLowerCase().replace(/\s+/g, '-');
}
